<template>
  <div id="contenedor-contratos-eventos">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-tool-bar titulo="Catálogo de Contratos Eventos" class="rounded-xl">
            <template v-slot:opciones-derecha>
              <v-btn
                color="primary"
                class="white--text"
                rounded
                @click="dialog = true"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listadoContratosEventos"
            :items-per-page="5"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                class="mr-2"
                color="blue darken-2"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                class="mr-2"
                color="red darken-2"
                @click="catalogoContratoEventoEliminar = item; showDialogEliminar = true"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              No hay contratos eventos registrados.
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
        <agregar-catalogo-contrato-evento @cerrar="dialog = false" />
      </v-dialog>
      <v-dialog v-model="showDialogEliminar" max-width="500px" persistent>
        <v-card>
          <v-card-title>
            Confirmar Eliminación
          </v-card-title>
          <v-card-text>
            ¿Estás seguro de que deseas eliminar este contrato evento?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="showDialogEliminar = false"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3"
            />
            <custom-button
              @click="eliminarCatalogoContratoEvento"
              tipo="formAceptar"
              label="Eliminar"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarCatalogoContratoEvento from '@/components/administracion/configuracion/catalogos/contratos.eventos/Agregar.vue';
import mixCatalogoContratosEventos from '@/components/administracion/configuracion/catalogos/contratos.eventos/mixContratosEventos';

export default {
  name: 'CatalogoContratosEventosView',
  mixins: [mixCatalogoContratosEventos],
  components: {
    TituloToolBar,
    AgregarCatalogoContratoEvento,
    CustomButton,
  },
  data() {
    return {
      dialog: false,
      showDialogEliminar: false,
      catalogoContratoEventoEliminar: {},
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Orden', value: 'orden' },
        {
          text: 'Acciones', value: 'acciones', sortable: false, width: '200px',
        },
      ],
    };
  },
  methods: {
    eliminarCatalogoContratoEvento() {
      this.mixEliminarCatalogoContratoEvento(this.catalogoContratoEventoEliminar.id);
      this.showDialogEliminar = false;
    },
    cerrar() {
      this.dialog = false;
    },
  },
  computed: {
    listadoContratosEventos() {
      if (!this.catalogoContratosEventos) return [];
      return this.catalogoContratosEventos;
    },
  },
};
</script>

<style lang="scss">

</style>
